// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SegmentedButton_segmentedButton__U7AJx {
    margin-right: -1px;
    color: var(--text-default);
    background-color: var(--selection-fill-selection-off);
    border: 1px solid var(--selection-stroke-selection-off);
    outline: none;
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
    text-align: left;
    white-space: nowrap;
}

.SegmentedButton_segmentedButton__U7AJx.SegmentedButton_active__rnfh9 {
    border-color: transparent;
    z-index: 2;
}
.SegmentedButton_segmentedButton__U7AJx:not(.SegmentedButton_active__rnfh9) {
    z-index: 1;
}

.SegmentedButton_segmentedButton__U7AJx:not(:active):focus-visible {
    outline: 2px solid var(--selection-stroke-selection-on-focus);
    outline-offset: -3px;
}

.SegmentedButton_segmentedButton__U7AJx:not(.SegmentedButton_active__rnfh9):active {
    background: var(--selection-fill-selection-off-press) !important;
}

.SegmentedButton_segmentedButton__U7AJx:not(.SegmentedButton_active__rnfh9):hover {
    background: var(--selection-fill-selection-off-hover);
}

.SegmentedButton_segmentedButton__U7AJx:not(:active):not(.SegmentedButton_active__rnfh9):focus {
    outline: 2px solid var(--color-blue-40);
    outline-offset: -3px;
}

.SegmentedButton_segmentedButton__U7AJx.SegmentedButton_active__rnfh9 {
    color: white;
    background: var(--selection-fill-selection-on);
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/SegmentedButton/SegmentedButton.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,qDAAqD;IACrD,uDAAuD;IACvD,aAAa;IACb,uHAAuH;IACvH,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA;IACI,6DAA6D;IAC7D,oBAAoB;AACxB;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,8CAA8C;AAClD","sourcesContent":[".segmentedButton {\n    margin-right: -1px;\n    color: var(--text-default);\n    background-color: var(--selection-fill-selection-off);\n    border: 1px solid var(--selection-stroke-selection-off);\n    outline: none;\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-weight: 400;\n    text-align: left;\n    white-space: nowrap;\n}\n\n.segmentedButton.active {\n    border-color: transparent;\n    z-index: 2;\n}\n.segmentedButton:not(.active) {\n    z-index: 1;\n}\n\n.segmentedButton:not(:active):focus-visible {\n    outline: 2px solid var(--selection-stroke-selection-on-focus);\n    outline-offset: -3px;\n}\n\n.segmentedButton:not(.active):active {\n    background: var(--selection-fill-selection-off-press) !important;\n}\n\n.segmentedButton:not(.active):hover {\n    background: var(--selection-fill-selection-off-hover);\n}\n\n.segmentedButton:not(:active):not(.active):focus {\n    outline: 2px solid var(--color-blue-40);\n    outline-offset: -3px;\n}\n\n.segmentedButton.active {\n    color: white;\n    background: var(--selection-fill-selection-on);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"segmentedButton": `SegmentedButton_segmentedButton__U7AJx`,
	"active": `SegmentedButton_active__rnfh9`
};
export default ___CSS_LOADER_EXPORT___;
